import { DISPLAY_STYLE_OPTIONS } from "@/react/components/Paywalls/Admin/PaywallsAdmin/FormModal/CheckoutTab/constants";
import type { TestimonialProperty } from "@/react/types/PaywallCustomization";

import { usePaywallCustomizationContext } from "../PaywallCustomizationProvider";
import { QuotationMark } from "./QuotationMark";
import { Stars } from "./Stars";
import { Testimonial } from "./Testimonial";

export const Testimonials = () => {
  const { paywallCustomization } = usePaywallCustomizationContext();

  const { enabled: isTestimonialEnabled, testimonials } =
    paywallCustomization?.testimonial_properties || {
      enabled: false,
      testimonials: [],
    };

  if (!isTestimonialEnabled) {
    return null;
  }

  return (
    <div
      className="flex flex-col gap-y-[2.125rem]"
      data-testid="testimonials-container"
    >
      {testimonials.map((testimonial: TestimonialProperty) => (
        <Testimonial key={testimonial.id} {...testimonial}>
          {testimonial.display_style.type ===
            DISPLAY_STYLE_OPTIONS.QUOTATION_MARK && (
            <QuotationMark color={testimonial.display_style.color} />
          )}
          {testimonial.display_style.type === DISPLAY_STYLE_OPTIONS.STARS && (
            <Stars color={testimonial.display_style.color} />
          )}
        </Testimonial>
      ))}
    </div>
  );
};
